import type { FluentVariable } from "@fluent/bundle"

import type { TranslationKey } from "../../../../../../modules/localization/translations"
import type { ResourceFilterElementValue } from "../../../createOrderTypes"

import { SITTINGS_FILTER_IDENTIFIER } from "./meetingFit"

type L10n = { getString: (id: TranslationKey, args?: Record<string, FluentVariable>) => string }

const RESOURCE_TYPE_ID_TO_TRANSLATION_KEY: Record<number, TranslationKey> = {
    1: "resource-booking-chip-filter-rooms",
    2: "resource-booking-chip-filter-equipment",
    4: "resource-booking-chip-filter-cars",
}

// only the filters `filterResources` actually applies
const FILTER_TOOLTIP_TRANSLATION_KEY: Partial<Record<string, TranslationKey>> = {
    resourceTypeIds: "resource-booking-chip-filter-tooltip-resourcetypeids",
    [SITTINGS_FILTER_IDENTIFIER]: "resource-booking-chip-filter-tooltip-sittings",
    serviceCenterIds: "resource-booking-chip-filter-tooltip-servicecenterids",
    floors: "resource-booking-chip-filter-tooltip-floors",
    fixedAvIds: "resource-booking-chip-filter-tooltip-fixedavids",
    tableSetupIds: "resource-booking-chip-filter-tooltip-tablesetupids",
}

export function getResourceFilterValueDisplayLabel(
    identifier: string,
    value: ResourceFilterElementValue,
    l10n: L10n,
): string {
    if (identifier === "resourceTypeIds") {
        const numValue = typeof value.value === "number" ? value.value : Number(value.value)
        const key = RESOURCE_TYPE_ID_TO_TRANSLATION_KEY[numValue]
        if (key) return l10n.getString(key)
    }
    return String(value.key)
}

export function getResourceFilterTooltip(
    identifier: string,
    values: ReadonlyArray<ResourceFilterElementValue>,
    fallbackName: string,
    l10n: L10n,
): string {
    const key = FILTER_TOOLTIP_TRANSLATION_KEY[identifier]
    if (!key) return fallbackName
    if (identifier !== SITTINGS_FILTER_IDENTIFIER) return l10n.getString(key)

    const seats = values[0]?.value
    return seats === undefined ? fallbackName : l10n.getString(key, { count: Number(seats) })
}
